import { render, staticRenderFns } from "./DepartmentSection.vue?vue&type=template&id=e63f840a&"
import script from "./DepartmentSection.vue?vue&type=script&lang=js&"
export * from "./DepartmentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports